module.exports = __webpack_public_path__ + "static/media/bowen-56.3dbaf7ff.jpg";